'use strict';
import {AjaxFactory} from './AjaxFactory';
import {HttpMethod} from './enums';

/**
 * @param {ReduxObservableListOptions} options
 */
export function buildDeleteFactory(options) {
  return new AjaxFactory(buildDeleteRequestOptions(options));
}

/**
 * @param {ReduxObservableListOptions} options
 * @return {AjaxFactoryOptions}
 */
export function buildDeleteRequestOptions(options) {
  return {
    crossDomain: options.crossDomain,
    method: HttpMethod.DELETE,
    useBody: false,
    url: getDeleteUrl(options),
    getToken: options.getToken,
  };
}

/**
 * @param {ReduxObservableListOptions} options
 * @return {Function}
 */
export function getDeleteUrl(options) {
  /**
   * @param {Object} payload
   * @return {String}
   */
  return function getDeleteUrlCurried(payload) {
    const baseUrl = [
      `${options.baseApiUrl}/${getDeletePath(options, payload.id, payload)}`,
    ];

    if (options.deleteParams) {
      baseUrl.push(`&${options.deleteParams}`);
    }

    return baseUrl.join('');
  }
}

/**
 * @param {ReduxObservableListOptions} options
 * @param {String} id
 * @param {Object} payload
 * @return {String}
 */
function getDeletePath(options, id, payload) {
  return options.deleteItemPath(id, payload);
}



// WEBPACK FOOTER //
// ./src/js/_libs/redux-observable-list/src/defaultDeleteFactory.js